import { useState } from 'react'
import UserProfileModal from '../components/UserProfileModal'

export default function Invites({ currentUserId, requests, onUpdateStatus, selectedRequestId, setSelectedRequestId, ratings, submitRating, ratingText, setRatingText, ratingScore, setRatingScore }) {
  const [profileUser, setProfileUser] = useState(null)

  return (
    <section>
      {profileUser && <UserProfileModal user={profileUser} onClose={() => setProfileUser(null)} />}
      <div className="fade-up glass-card rounded-3xl border border-white/60 p-6 shadow-xl">
        <h2 className="title-font text-2xl font-bold text-gray-900">Invites & Requests</h2>
        {requests.length === 0 ? (
          <p className="mt-4 text-sm text-gray-600">No requests yet.</p>
        ) : (
          <div className="mt-4 space-y-3">
            {requests.map(req => {
              const isSelected = selectedRequestId === req.id
              const canCancel = req.status === 'PENDING' && req.senderId === currentUserId
              const otherUser = req.senderId === currentUserId ? req.receiver : req.sender
              return (
                <div key={req.id} onClick={() => setSelectedRequestId(isSelected ? null : req.id)}
                  className={`cursor-pointer rounded-2xl border-2 p-4 transition ${isSelected ? 'border-orange-500 bg-orange-50' : 'border-gray-200 hover:border-orange-300'}`}>
                  <div className="flex items-center justify-between gap-2">
                    <button
                      className="flex items-center gap-3 min-w-0 text-left hover:opacity-80 transition"
                      onClick={e => { e.stopPropagation(); setProfileUser(otherUser) }}
                      title={`View ${otherUser.name}'s profile`}
                    >
                      <img src={otherUser.profilePicture || `https://api.dicebear.com/7.x/thumbs/svg?seed=${encodeURIComponent(otherUser.name)}`} className="h-10 w-10 rounded-xl object-cover bg-orange-100 shrink-0 ring-2 ring-orange-200 ring-offset-1" alt={otherUser.name} />
                      <div className="min-w-0">
                        <p className="text-sm font-semibold text-gray-900 truncate underline decoration-dotted underline-offset-2">{otherUser.name}</p>
                        <p className="text-xs text-gray-600">{req.senderId === currentUserId ? 'Sent' : 'Received'} · <span className={`font-bold ${req.status === 'PENDING' ? 'text-yellow-600' : req.status === 'ACCEPTED' ? 'text-green-600' : req.status === 'CANCELLED' ? 'text-gray-500' : 'text-red-600'}`}>{req.status}</span></p>
                      </div>
                    </button>
                    {req.status === 'PENDING' && req.receiverId === currentUserId && (
                      <div className="flex gap-2 shrink-0">
                        <button onClick={e => { e.stopPropagation(); onUpdateStatus(req.id, 'ACCEPTED') }} className="rounded-full bg-green-600 px-3 py-1 text-xs font-semibold text-white hover:bg-green-700">Accept</button>
                        <button onClick={e => { e.stopPropagation(); onUpdateStatus(req.id, 'DECLINED') }} className="rounded-full bg-red-600 px-3 py-1 text-xs font-semibold text-white hover:bg-red-700">Decline</button>
                      </div>
                    )}
                  </div>
                  {isSelected && canCancel && (
                    <div className="mt-4 border-t pt-4">
                      <p className="mb-2 text-xs font-bold uppercase text-gray-500">Cancel this request</p>
                      <p className="text-sm text-gray-600">You can cancel this pending request if you no longer want to meet.</p>
                      <button
                        onClick={e => { e.stopPropagation(); onUpdateStatus(req.id, 'CANCELLED') }}
                        className="mt-3 rounded-full bg-gray-900 px-4 py-2 text-sm font-semibold text-white hover:bg-black"
                      >
                        Cancel Request
                      </button>
                    </div>
                  )}
                  {isSelected && req.status === 'ACCEPTED' && (
                    <div className="mt-4 border-t pt-4">
                      <p className="mb-2 text-xs font-bold uppercase text-gray-500">Rate your experience with {otherUser.name}</p>
                      <div className="flex gap-1">
                        {[1,2,3,4,5].map(score => (
                          <button key={score} onClick={e => { e.stopPropagation(); setRatingScore(score) }}
                            className={`text-2xl transition ${ratingScore >= score ? 'text-yellow-500' : 'text-gray-300 hover:text-yellow-400'}`}>★</button>
                        ))}
                      </div>
                      <textarea placeholder="Optional comment..." value={ratingText} onChange={e => setRatingText(e.target.value)} onClick={e => e.stopPropagation()}
                        className="mt-3 w-full rounded-xl border border-orange-200 bg-white px-4 py-2 text-sm" rows={2} />
                      <button onClick={e => { e.stopPropagation(); submitRating(req.id, otherUser.id) }}
                        className="mt-2 rounded-full bg-yellow-500 px-4 py-2 text-sm font-semibold text-white hover:bg-yellow-600">Submit Rating</button>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
